/*
  1ASOL Suche · Test-Theme „Claude Suche-Test 23-09-2026“
  Eigene Schnellsuche und Suchergebnisseite auf Basis eines kompakten Produktindex.

  Datenquellen (alles aus dem Theme, keine App):
  - /collections/all?view=suchindex&sort_by=best-selling&page=N  (templates/collection.suchindex.liquid)
  - /collections/all?view=suchindex-kat                           (templates/collection.suchindex-kat.liquid)
  - window.ASOL_SUCHBEGRIFFE                                      (assets/1asol-suchbegriffe.js, aus GA4)
  - /products/<handle>?view=suchkarte                            (Theme-Produktkarte für die Ergebnisseite)

  Die Suchlogik (Teil 1) läuft auch in Node, damit sie gegen die echten Suchbegriffe getestet werden kann.
*/
(function (root) {
  'use strict';

  /* =========================================================
     Teil 1: Suchlogik
     ========================================================= */

  var STOPPWORTE = { fuer: 1, mit: 1, und: 1, der: 1, die: 1, das: 1, den: 1, von: 1, inkl: 1, the: 1, ein: 1, eine: 1, zu: 1, im: 1, auf: 1, fur: 1, oder: 1 };

  // Produkttyp -> zusätzliche Suchwörter (so findet „Smartmeter“ auch „Power Sensor“, „Speicher“ auch „Battery-Box“)
  var TYP_WOERTER = {
    'Batteriespeicher': 'speicher batteriespeicher stromspeicher akku batterie heimspeicher',
    'Batteriemodul': 'speicher batteriemodul modul erweiterung erweiterungsmodul akku batterie',
    'Balkonspeicher': 'speicher balkonspeicher balkonkraftwerk akku batterie stromspeicher',
    'Batteriemanagement': 'speicher bms steuereinheit zubehoer',
    'Hybridwechselrichter': 'wechselrichter hybridwechselrichter hybrid inverter',
    'String-Wechselrichter': 'wechselrichter inverter stringwechselrichter',
    'Mikrowechselrichter': 'wechselrichter mikrowechselrichter microinverter inverter balkonkraftwerk',
    'Solarmodule': 'solarmodul solarmodule modul module pv panel photovoltaik',
    'Wallbox': 'wallbox ladestation charger ladegeraet eauto',
    'Klimagerät': 'klimaanlage klimageraet klima split',
    'Wärmepumpe': 'waermepumpe heizung',
    'Smart Meter': 'smartmeter zaehler energiezaehler stromzaehler',
    'Backup- & Combiner-Box': 'backup notstrom ersatzstrom combiner zubehoer',
    'Energiemanagement': 'energiemanagement ems steuerung',
    'Montageset': 'montage montagesystem unterkonstruktion halterung zubehoer',
    'Solarkabel': 'kabel solarkabel zubehoer',
    'Steckverbinder': 'stecker steckverbinder zubehoer',
    'Optimierer': 'optimierer',
    'PV-Komplettanlage': 'komplettset komplettanlage set pv anlage',
    'Set mit Wechselrichter': 'set komplettset',
    'Zubehör': 'zubehoer'
  };

  // Titel-Muster -> zusätzliche Suchwörter
  var TITEL_REGELN = [
    [/smart ?meter|energy ?meter|power ?sensor|dtsu|ddsu|ct00[23]|\b3em\b|ecotracker|p1 ?meter/, 'smartmeter zaehler energiezaehler'],
    [/wallbox|charger|wattpilot|ladestation/, 'wallbox ladestation charger'],
    [/backup|notstrom|ersatzstrom/, 'backup notstrom ersatzstrom'],
    [/balkon|plug-in|plug in/, 'balkonkraftwerk'],
    [/\bspd\b|ueberspannung/, 'ueberspannungsschutz blitzschutz'],
    [/scharger/, 'smart charger smartcharger']
  ];

  // Marken und Modelle, die oft gesucht werden, die es im Shop aber nicht gibt (GA4, März bis September 2026)
  // Marken und Modelle, die oft gesucht werden, die es im Shop aber nicht gibt (Shopify-Suchdaten Jan 2025 bis Sept 2026).
  // Treffen immer vor der normalen Suche, weil die sonst Zufallstreffer liefert („smart box“ -> SmartGuard Backup Box).
  var ALTERNATIVEN = [
    [/\bct ?0?0?3\b|\bct003\b/, 'Marstek CT003', 'Smart Meter', 'smart meter', ['Smart Meter', 'Energiemanagement']],
    [/\bshel+y\b/, 'Shelly', 'Smart Meter', 'smart meter', ['Smart Meter', 'Energiemanagement']],
    [/eco ?tracker|everhome|lesekopf|\btibber\b|powerfox|\bp1\b/, null, 'Smart Meter', 'smart meter', ['Smart Meter', 'Energiemanagement']],
    [/smart ?box/, 'Marstek Smart Box', 'Marstek', 'marstek', null],
    [/jupiter/, 'Marstek Jupiter', 'Marstek Speicher', 'marstek', ['Balkonspeicher', 'Batteriespeicher']],
    [/venus ?e ?v?4|venus e4/, 'Marstek Venus E 4.0', 'Marstek Venus E', 'venus e', null],
    [/\blv[sl]\b/, 'BYD LVS', 'BYD Batteriespeicher', 'byd', ['Batteriespeicher', 'Batteriemodul']],
    [/kostal|plentic|\bdeye\b|growatt|tl-?xe|\bsolis\b|solar ?e+dge|victron/, null, 'Hybrid-Wechselrichter', 'hybrid wechselrichter', ['Hybridwechselrichter']],
    [/dyness|sigen|pylontech|\bsenec\b|\bvarta\b|e3dc/, null, 'Batteriespeicher', 'batteriespeicher', ['Batteriespeicher']],
    [/\bgo-?e\b|easee|\bkeba\b/, null, 'Wallboxen', 'wallbox', ['Wallbox']],
    [/porta ?split/, 'Midea PortaSplit', 'Midea Klimageräte', 'klimaanlage', ['Klimagerät']],
    [/enwitec|netzumschalter|generatoranschluss|lastumschalter/, null, 'Backup-Boxen', 'backup', ['Backup- & Combiner-Box']]
  ];

  var ZUBEHOER_TYPEN = { 'Zubehör': 1, 'Batteriemodul': 1, 'Batteriemanagement': 1, 'Backup- & Combiner-Box': 1, 'Steckverbinder': 1, 'Solarkabel': 1 };
  var ZUBEHOER_HINWEIS = /^(modul|erweiter|zubehoer|kabel|sockel|bms|combiner|backup|stecker|mc4|montage|halter|bcu|base|basis|box)/;
  var INTERNE_TAGS = /^(geizhals|dp-stop+|mwst\d*|black friday|kein-billiger-feed|bestseller|kategorie:.*|kapazitaet .*|leistung .*|serie .*|1asol|\d.*)$/i;

  function falten(s) {
    return String(s == null ? '' : s).toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  function tokens(s) {
    var n = falten(s)
      .replace(/(\d),(\d)/g, '$1.$2')
      .replace(/([a-z])(\d+\.\d+)/g, '$1 $2')
      .replace(/\+/g, ' plus ')
      .replace(/[^a-z0-9.]+/g, ' ');
    var aus = [];
    n.split(' ').forEach(function (t) {
      t = t.replace(/^\.+|\.+$/g, '');
      if (!t) return;
      if (/^\d+(\.\d+)?$/.test(t)) { aus.push(t); return; }
      t.split('.').forEach(function (x) { if (x) aus.push(x); });
    });
    return aus;
  }

  function istZahl(t) { return /^\d+(\.\d+)?$/.test(t); }

  // sh10rt -> sh, 10, rt · luna2000 -> luna, 2000 · ct002 -> ct, 002
  function teile(t) {
    var p = t.match(/[a-z]+|\d+(?:\.\d+)?/g) || [];
    return p.length > 1 ? p : [];
  }

  function erweitern(tt) {
    var aus = tt.slice();
    tt.forEach(function (t) { teile(t).forEach(function (x) { aus.push(x); }); });
    for (var i = 0; i < tt.length - 1; i++) aus.push(tt[i] + tt[i + 1]);
    return eindeutig(aus);
  }

  function eindeutig(a) {
    var s = {}, aus = [];
    a.forEach(function (x) { if (x && !s[x]) { s[x] = 1; aus.push(x); } });
    return aus;
  }

  function levenshtein(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var v0 = [], v1 = [], i, j;
    for (j = 0; j <= b.length; j++) v0[j] = j;
    for (i = 0; i < a.length; i++) {
      v1[0] = i + 1;
      var zeileMin = v1[0];
      for (j = 0; j < b.length; j++) {
        var k = a[i] === b[j] ? 0 : 1;
        v1[j + 1] = Math.min(v1[j] + 1, v0[j + 1] + 1, v0[j] + k);
        if (v1[j + 1] < zeileMin) zeileMin = v1[j + 1];
      }
      if (zeileMin > max) return max + 1;
      var tmp = v0; v0 = v1; v1 = tmp;
    }
    return v0[b.length];
  }

  function Index(produkte, kategorien) {
    var gesamt = produkte.length || 1;
    var vokabel = {};
    this.docs = produkte.map(function (p, rang) {
      var titelTok = tokens(p.t);
      var typ = p.y || '';
      var zusatz = (TYP_WOERTER[typ] || '') + ' ' + TITEL_REGELN.map(function (r) {
        return r[0].test(falten(p.t)) ? r[1] : '';
      }).join(' ');
      var tags = (p.g || []).filter(function (g) { return !INTERNE_TAGS.test(String(g).trim()); }).join(' ');
      var d = {
        p: p,
        T: erweitern(titelTok),
        V: erweitern(tokens(p.v)),
        S: erweitern(tokens(p.s)),
        G: eindeutig(tokens(tags + ' ' + typ + ' ' + zusatz)).filter(function (t) { return !istZahl(t); }),
        titel: titelTok,
        tagsKompakt: (p.g || []).map(function (g) { return tokens(g).join(''); }),
        typT: eindeutig(tokens((TYP_WOERTER[typ] || '') + ' ' + typ)),
        pop: 1 - rang / gesamt,
        bestseller: (p.g || []).some(function (g) { return /^bestseller$/i.test(g); }),
        zubehoer: !!ZUBEHOER_TYPEN[typ]
      };
      var imDoc = {};
      [d.T, d.V, d.S, d.G].forEach(function (a) { a.forEach(function (t) { imDoc[t] = 1; }); });
      Object.keys(imDoc).forEach(function (t) { vokabel[t] = (vokabel[t] || 0) + 1; });
      return d;
    });
    this.vokabel = vokabel;
    this.vokabelListe = Object.keys(vokabel).filter(function (t) { return t.length >= 4 && !/\d/.test(t); });
    this.kategorien = (kategorien || []).filter(function (k) {
      return k.n > 0 && k.h !== 'all' && k.h !== 'frontpage' && !/geizhals|feed|google|idealo|billiger|solute|test|alle produkte/i.test(k.t + ' ' + k.h);
    }).map(function (k) { k.T = erweitern(tokens(k.t)); return k; });
  }

  Index.prototype.anfrage = function (q) {
    var self = this;
    var roh = tokens(q).filter(function (t) { return !STOPPWORTE[t]; });
    var tt = [];
    roh.forEach(function (t) {
      if (!self.vokabel[t]) {
        var p = teile(t);
        if (p.length > 1 && p.every(function (x) { return self.vokabel[x] || istZahl(x); })) { p.forEach(function (x) { tt.push(x); }); return; }
      }
      tt.push(t);
    });
    return tt.map(function (t) {
      var fz = null;
      if (!istZahl(t) && t.length >= 4 && !self.vokabel[t]) {
        // Tippfehler: nur die nächstgelegenen und häufigsten Wörter (mastek -> marstek, nicht master)
        var max = t.length >= 7 ? 2 : 1, kand = [], bester = max + 1;
        self.vokabelListe.forEach(function (v) {
          if (Math.abs(v.length - t.length) > max) return;
          var dist = levenshtein(t, v, max);
          if (dist <= max) { kand.push([v, dist]); if (dist < bester) bester = dist; }
        });
        kand = kand.filter(function (k) { return k[1] === bester; });
        var maxDf = 0;
        kand.forEach(function (k) { maxDf = Math.max(maxDf, self.vokabel[k[0]]); });
        kand.forEach(function (k) { if (self.vokabel[k[0]] * 2 >= maxDf) (fz = fz || {})[k[0]] = 1; });
      }
      // Kurze Wörter wie „sma“ oder „hvs“: nur exakte Treffer, wenn es das Wort genau so gibt (sonst findet „sma“ alles mit „smart“)
      return { t: t, zahl: istZahl(t), fz: fz, exaktNoetig: t.length <= 3 && !!self.vokabel[t] };
    });
  };

  function passt(q, liste) {
    var best = 0, t = q.t;
    for (var i = 0; i < liste.length; i++) {
      var d = liste[i], s = 0;
      if (d === t) return 1;
      if (q.zahl) {
        if (d.indexOf(t) === 0 && d.charAt(t.length) === '.') s = 0.5;
      } else if (q.exaktNoetig) {
        s = 0;
      } else if (d.indexOf(t) === 0) {
        s = t.length >= 3 ? 0.85 : 0.7;
      } else if (t.length >= 4 && d.length > t.length && d.lastIndexOf(t) === d.length - t.length) {
        s = 0.8; // Wortende bei Zusammensetzungen: solarKABEL, batterieSPEICHER
      } else if (t.length >= 4 && d.indexOf(t) > 0) {
        s = 0.55;
      } else if (q.fz && q.fz[d]) {
        s = 0.6;
      }
      if (s > best) best = s;
    }
    return best;
  }

  function folgeImTitel(qt, titel) {
    if (qt.length < 2) return false;
    for (var i = 0; i <= titel.length - qt.length; i++) {
      var ok = true;
      for (var j = 0; j < qt.length; j++) {
        var w = titel[i + j];
        if (!(w === qt[j].t || (!qt[j].zahl && w.indexOf(qt[j].t) === 0))) { ok = false; break; }
      }
      if (ok) return true;
    }
    return false;
  }

  function bewerte(d, qt, zubehoerGewollt, qKompakt) {
    var summe = 0, fehlt = 0, imTitel = 0;
    for (var i = 0; i < qt.length; i++) {
      var q = qt[i];
      var t = passt(q, d.T), v = passt(q, d.V);
      var b = Math.max(t * 3, v * 3, passt(q, d.S) * 2.5, q.zahl ? 0 : passt(q, d.G) * 1.2);
      if (b === 0) fehlt++; else summe += b;
      if (t >= 0.8 || v >= 0.8) imTitel++;
    }
    if (summe === 0) return null;
    var s = summe;
    if (imTitel === qt.length) s += 3;
    if (folgeImTitel(qt, d.titel)) s += 2;
    s += d.p.a ? 2 : -4;
    s += d.pop * 2;
    if (d.bestseller) s += 0.5;
    if (d.zubehoer && !zubehoerGewollt) s -= 1.5;
    // Gepflegter Tag passt genau („AC-Speicher“): dann zählt wie in der Kollektion der Bestseller-Rang, nicht der Titeltext
    if (qKompakt && d.tagsKompakt.indexOf(qKompakt) !== -1) s = 30 + d.pop * 6 + (d.p.a ? 2 : -4);
    // Das Produkt IST das Gesuchte (Smart Meter bei „smart meter“), nicht nur „inkl. Smart Meter“
    if (qt.some(function (q) { return !q.zahl && passt(q, d.typT) >= 0.8 && passt(q, d.V) === 0; })) s += 2.5;
    return { s: s, fehlt: fehlt };
  }

  Index.prototype.suche = function (q) {
    var alle = this.anfrage(q);
    if (!alle.length) return { treffer: [], exakt: true, qt: alle, ignoriert: [] };
    var self = this;
    // Wörter, die in keinem Produkt vorkommen (auch nicht als Tippfehler), werden weggelassen: „sbr nachrüsten“ sucht „sbr“
    var bekannt = alle.filter(function (x) { return self.bekannt(x); });
    var ignoriert = alle.filter(function (x) { return !self.bekannt(x); }).map(function (x) { return x.t; });
    var ALLGEMEIN = { pro: 1, plus: 1, max: 1, mini: 1, smart: 1, set: 1, kw: 1, kwh: 1, neu: 1, box: 1, w: 1, wp: 1, ac: 1, dc: 1 };
    var stark = bekannt.some(function (x) { return !x.zahl && x.t.length >= 3 && !ALLGEMEIN[x.t]; });
    if (!bekannt.length || (ignoriert.length && !stark)) return { treffer: [], exakt: false, qt: alle, ignoriert: ignoriert };
    var r = this.sucheMit(bekannt);
    r.ignoriert = ignoriert;
    if (ignoriert.length) r.exakt = false;
    return r;
  };

  Index.prototype.bekannt = function (x) {
    if (this.vokabel[x.t] || x.fz) return true;
    for (var i = 0; i < this.vokabelListe.length; i++) {
      var v = this.vokabelListe[i];
      if (x.zahl ? v.indexOf(x.t + '.') === 0 : (v.indexOf(x.t) === 0 || (x.t.length >= 4 && v.indexOf(x.t) > 0))) return true;
    }
    if (x.zahl) { for (var w in this.vokabel) if (w === x.t || w.indexOf(x.t + '.') === 0) return true; }
    return false;
  };

  Index.prototype.sucheMit = function (qt) {
    var zubehoerGewollt = qt.some(function (x) { return ZUBEHOER_HINWEIS.test(x.t); });
    var qKompakt = qt.length >= 2 ? qt.map(function (x) { return x.t; }).join('') : '';
    var alle = [];
    this.docs.forEach(function (d) {
      var r = bewerte(d, qt, zubehoerGewollt, qKompakt);
      if (r) alle.push({ d: d, s: r.s, fehlt: r.fehlt });
    });
    var exakt = alle.filter(function (x) { return x.fehlt === 0; });
    var istExakt = exakt.length > 0;
    var liste = exakt;
    if (!istExakt && qt.length >= 3) {
      liste = alle.filter(function (x) { return x.fehlt <= 1; });
      liste.forEach(function (x) { x.s -= x.fehlt * 3; });
    }
    liste.sort(function (a, b) { return b.s - a.s || b.d.pop - a.d.pop; });
    return { treffer: liste, exakt: istExakt, qt: qt };
  };

  Index.prototype.kategorienFuer = function (q, ergebnis, max) {
    var qt = this.anfrage(q);
    if (!qt.length) return [];
    var top = ergebnis && ergebnis.treffer[0] ? ergebnis.treffer[0].d : null;
    var aus = [];
    this.kategorien.forEach(function (k) {
      var summe = 0, getroffen = 0;
      qt.forEach(function (x) { var m = passt(x, k.T); if (m) { summe += m; getroffen++; } });
      if (!getroffen || getroffen < Math.ceil(qt.length / 2)) return;
      var s = summe + (getroffen === qt.length ? 2 : 0);
      if (getroffen === qt.length && summe === qt.length) s += 2;
      if (top && k.T.some(function (t) {
        return top.G.indexOf(t) !== -1 && !qt.some(function (x) { return passt(x, [t]) > 0; });
      })) s += 1;
      s += Math.min(k.n, 60) / 100;
      aus.push({ k: k, s: s });
    });
    aus.sort(function (a, b) { return b.s - a.s; });
    return aus.slice(0, max || 5).map(function (x) { return x.k; });
  };

  function vorschlaege(q, begriffe, max) {
    var qt = tokens(q);
    var qn = qt.join(' ');
    if (!qt.length) return (begriffe || []).slice(0, max).map(function (b) { return b[0]; });
    var aus = [];
    (begriffe || []).forEach(function (b) {
      var bt = tokens(b[0]);
      var ok = qt.every(function (t, i) {
        var letztes = i === qt.length - 1;
        return bt.some(function (w) { return letztes ? w.indexOf(t) === 0 : (w === t || w.indexOf(t) === 0); });
      });
      if (ok) aus.push(b);
    });
    aus.sort(function (a, b) {
      var aGleich = tokens(a[0]).join(' ') === qn ? 1 : 0, bGleich = tokens(b[0]).join(' ') === qn ? 1 : 0;
      return bGleich - aGleich || b[1] - a[1];
    });
    return aus.slice(0, max).map(function (b) { return b[0]; });
  }

  var SERVICE = [
    [/^(versand|lieferung|lieferzeit|spedition|paket|zustellung)/, 'Versand und Lieferzeiten', '/policies/shipping-policy'],
    [/^(rueckgabe|widerruf|retoure|umtausch|zurueck|storno)/, 'Rückgabe und Widerruf', '/policies/refund-policy'],
    [/^(vorkasse|zahlung|zahlungsart|paypal|klarna|rechnung|ueberweisung|kreditkarte|ratenkauf)/, 'Zahlungsarten und AGB', '/policies/terms-of-service'],
    [/^(kontakt|telefon|hotline|beratung|support|hilfe|email)/, 'Kontakt und Beratung', '/pages/kontakt'],
    [/^(garantie|gewaehrleistung|defekt|reklamation)/, 'Garantie und Herstellergarantien', '/pages/garantiebedingungen-hersteller-garantien'],
    [/^(mwst|mehrwertsteuer|ust|umsatzsteuer|nullsteuer|steuer)/, '0 % Mehrwertsteuer (§ 12 Abs. 3 UStG)', '/pages/mehrwertsteuerbefreiung-12-abs-3-ustg'],
    [/^(gutschein|rabatt|code|coupon)/, 'Aktuelle Rabattcodes', '/pages/1asol-rabattcodes-aktuelle-gutscheincodes'],
    [/^(bestellung|bestellstatus|sendung|tracking|konto|login|anmelden)/, 'Bestellung und Kundenkonto', '/account'],
    [/^(angebot|anfrage|gewerbe|haendler|projekt)/, 'Angebot anfragen', '/pages/request-for-quote']
  ];

  function serviceFuer(q) {
    var qt = tokens(q), aus = [];
    SERVICE.forEach(function (s) {
      if (qt.some(function (t) { return t.length >= 3 && s[0].test(t); })) aus.push({ t: s[1], u: s[2] });
    });
    return aus;
  }

  // Liefert {name, marke, suche} für eine Anfrage ohne Treffer, z. B. „shelly“ -> Smart Meter
  function alternativeFuer(q) {
    var n = tokens(q).join(' ');
    for (var i = 0; i < ALTERNATIVEN.length; i++) {
      var m = n.match(ALTERNATIVEN[i][0]);
      if (m) return { marke: ALTERNATIVEN[i][1] || q.trim(), name: ALTERNATIVEN[i][2], suche: ALTERNATIVEN[i][3], typen: ALTERNATIVEN[i][4] };
    }
    return null;
  }


  var api = { tokens: tokens, Index: Index, vorschlaege: vorschlaege, serviceFuer: serviceFuer, alternativeFuer: alternativeFuer, falten: falten };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  root.ASOL_SUCHE = api;

  if (typeof document === 'undefined') return;

  /* =========================================================
     Teil 2: Daten laden (einmal pro Sitzung, 30 Minuten Cache)
     ========================================================= */

  var CACHE_KEY = 'asol-suche-index-v1';
  var CACHE_MIN = 30;
  var indexVersprechen = null;
  var indexFertig = null;

  function ausCache() {
    try {
      var roh = sessionStorage.getItem(CACHE_KEY);
      if (!roh) return null;
      var d = JSON.parse(roh);
      if (!d || Date.now() - d.zeit > CACHE_MIN * 60000) return null;
      return d;
    } catch (e) { return null; }
  }

  function inCache(d) {
    try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(d)); } catch (e) { /* voll oder gesperrt */ }
  }

  function holeJson(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  function mitVorschau(url) {
    // Im Test-Theme per ?preview_theme_id aufgerufen: Index-Vorlagen gibt es nur in diesem Theme
    var id = root.Shopify && root.Shopify.theme && root.Shopify.theme.role !== 'main' ? root.Shopify.theme.id : null;
    return id ? url + '&preview_theme_id=' + id : url;
  }

  function ladeIndex() {
    if (indexVersprechen) return indexVersprechen;
    var c = ausCache();
    if (c) {
      indexFertig = new Index(c.produkte, c.kategorien);
      indexVersprechen = Promise.resolve(indexFertig);
      return indexVersprechen;
    }
    var basis = '/collections/all?view=suchindex&sort_by=best-selling';
    indexVersprechen = holeJson(mitVorschau(basis + '&page=1')).then(function (s1) {
      var weitere = [];
      for (var i = 2; i <= s1.seiten; i++) weitere.push(holeJson(mitVorschau(basis + '&page=' + i)));
      var kat = holeJson(mitVorschau('/collections/all?view=suchindex-kat')).catch(function () { return []; });
      return Promise.all([Promise.all(weitere), kat]).then(function (r) {
        var produkte = s1.produkte;
        r[0].forEach(function (s) { produkte = produkte.concat(s.produkte); });
        var d = { zeit: Date.now(), produkte: produkte, kategorien: r[1] };
        inCache(d);
        indexFertig = new Index(produkte, r[1]);
        return indexFertig;
      });
    });
    indexVersprechen.catch(function () { indexVersprechen = null; });
    return indexVersprechen;
  }

  /* =========================================================
     Teil 3: Darstellung
     ========================================================= */

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function geld(cent) {
    var betrag = (cent || 0) / 100;
    var zahl = betrag.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var fmt = root.theme && root.theme.moneyFormat;
    if (fmt && /\{\{\s*amount_with_comma_separator\s*\}\}/.test(fmt)) return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, zahl).replace(/<[^>]+>/g, '');
    return zahl + ' €';
  }

  // Markiert die gesuchten Wortanfänge im Titel
  function markiere(text, qt) {
    if (!qt || !qt.length) return esc(text);
    var teileQ = qt.filter(function (q) { return q.t.length >= 1; }).map(function (q) { return q.t; });
    return String(text).split(/(\s+|[-/()+,])/).map(function (wort) {
      var w = tokens(wort)[0] || '';
      var treffer = teileQ.some(function (t) { return w && (w === t || w.indexOf(t) === 0 || (t.length >= 4 && w.indexOf(t) > 0)); });
      return treffer ? '<mark>' + esc(wort) + '</mark>' : esc(wort);
    }).join('');
  }

  function verfuegbarkeit(p) {
    if (!p.a) return '<span class="ps1a-lz ps1a-lz--aus"><i></i>Nicht vorrätig · Lieferzeit auf Anfrage</span>';
    if (p.l) return '<span class="ps1a-lz ps1a-lz--bald"><i></i>' + esc(p.l) + '</span>';
    return '<span class="ps1a-lz ps1a-lz--da"><i></i>Auf Lager · Lieferung in 2–4 Werktagen</span>';
  }

  function preis(p) {
    if ((p.g || []).some(function (g) { return /^ecoflow$/i.test(g); })) return '<span class="ps1a-preis ps1a-preis--info">Preis auf Anfrage</span>';
    if (!p.p) return '<span class="ps1a-preis ps1a-preis--info">Preis auf Anfrage</span>';
    var alt = p.c && p.c > p.p ? '<s>' + geld(p.c) + '</s>' : '';
    return '<span class="ps1a-preis">' + alt + (p.pv ? '<small>ab </small>' : '') + geld(p.p) + '</span>';
  }

  function bild(p, gross) {
    if (!p.i) return '<span class="ps1a-bild ps1a-bild--leer"></span>';
    var src = gross ? p.i.replace(/width=\d+/, 'width=400') : p.i;
    return '<span class="ps1a-bild"><img src="' + esc(src) + '" alt="" loading="lazy" width="' + (gross ? 400 : 160) + '" height="' + (gross ? 400 : 160) + '"></span>';
  }

  function nurTypen(erg, typen) {
    if (typen && typen.length) erg.treffer = erg.treffer.filter(function (x) { return typen.indexOf(x.d.p.y) !== -1; });
    return erg;
  }

  function suchUrl(q) { return '/search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last'; }

  function vorschlagHtml(v, q) {
    // Getippten Teil normal, Ergänzung fett (wie bei Krannich)
    var qn = falten(q).trim();
    var vn = falten(v);
    var i = vn.indexOf(qn);
    var inhalt = i === 0 && qn ? esc(v.slice(0, qn.length)) + '<b>' + esc(v.slice(qn.length)) + '</b>' : '<b>' + esc(v) + '</b>';
    return '<li role="option" aria-selected="false"><a class="ps1a-vorschlag" href="' + suchUrl(v) + '">' + inhalt + '</a></li>';
  }

  function dropdownHtml(q, idx) {
    var alternative = alternativeFuer(q);
    var erg = alternative ? nurTypen(idx.suche(alternative.suche), alternative.typen) : idx.suche(q);
    var treffer = erg.treffer;
    var anzahl = treffer.length;
    var max = 40; // Liste scrollt in sich, rechte Spalte bleibt stehen
    var begr = vorschlaege(q, root.ASOL_SUCHBEGRIFFE, 6);
    var kats = idx.kategorienFuer(q, erg, 4);
    var service = serviceFuer(q);

    var html = '<div class="ps1a" data-ps1a>';
    html += '<div class="ps1a__haupt">';
    if (anzahl) {
      html += hinweisHtml(q, erg, alternative);
      html += '<div class="ps1a__kopf"><span>' + (alternative ? esc(alternative.name) : erg.exakt ? 'Produkte' : 'Ähnliche Produkte') + '</span><span class="ps1a__anzahl">' + anzahl + ' ' + (anzahl === 1 ? 'Treffer' : 'Treffer') + '</span></div>';
      html += '<ul class="ps1a__liste" role="listbox">';
      treffer.slice(0, max).forEach(function (x, i) {
        var p = x.d.p;
        html += '<li role="option" aria-selected="false" id="ps1a-opt-' + i + '">' +
          '<a class="ps1a-zeile" href="/products/' + esc(p.h) + '">' +
          bild(p) +
          '<span class="ps1a-zeile__text"><span class="ps1a-zeile__titel">' + markiere(p.t, erg.qt) + '</span>' + verfuegbarkeit(p) + '</span>' +
          preis(p) +
          '</a></li>';
      });
      html += '</ul>';
      var qAlle = alternative ? alternative.suche : q;
      html += '<a class="ps1a__alle" href="' + suchUrl(qAlle) + '">Alle ' + anzahl + ' Ergebnisse für „' + esc(qAlle) + '“ anzeigen</a>';
    } else {
      html += '<div class="ps1a__leer"><strong>Keine Produkte zu „' + esc(q) + '“ gefunden.</strong><br>Prüfen Sie die Schreibweise oder rufen Sie uns an: <a href="tel:+4952315681430">05231 5681430</a>. Wir prüfen gern, ob wir das Produkt besorgen können: <a href="/pages/kontakt">Anfrage senden</a></div>';
    }
    html += '</div>';

    html += '<aside class="ps1a__seite">';
    if (service.length) {
      html += '<div class="ps1a__block"><div class="ps1a__h">Service</div><ul>' + service.map(function (s) {
        return '<li role="option" aria-selected="false"><a class="ps1a-vorschlag" href="' + s.u + '">' + esc(s.t) + '</a></li>';
      }).join('') + '</ul></div>';
    }
    if (begr.length) {
      html += '<div class="ps1a__block"><div class="ps1a__h">Suchvorschläge</div><ul class="ps1a__chips">' + begr.map(function (v) { return vorschlagHtml(v, q); }).join('') + '</ul></div>';
    }
    if (kats.length) {
      html += '<div class="ps1a__block"><div class="ps1a__h">Kategorien</div><ul>' + kats.map(function (k) {
        return '<li role="option" aria-selected="false"><a class="ps1a-vorschlag" href="/collections/' + esc(k.h) + '">' + markiere(k.t, erg.qt) + ' <span class="ps1a__n">' + k.n + '</span></a></li>';
      }).join('') + '</ul></div>';
    }
    html += '</aside>';
    html += '<span class="hidden" data-predictive-search-live-region-count-value>' + anzahl + ' Produkte gefunden</span>';
    html += '</div>';
    return html;
  }

  // Hinweis über der Trefferliste: nicht geführtes Produkt oder weggelassenes Wort
  function hinweisHtml(q, erg, alternative) {
    if (alternative) {
      return '<div class="ps1a__hinweis"><strong>„' + esc(alternative.marke) + '“ führen wir derzeit nicht.</strong> Passende Alternativen aus unserem Sortiment finden Sie hier. ' +
        'Oder wir prüfen, ob wir es besorgen können: <a href="/pages/kontakt">Anfrage senden</a></div>';
    }
    if (erg.ignoriert && erg.ignoriert.length) {
      return '<div class="ps1a__hinweis">Zu „' + esc(erg.ignoriert.join(' ')) + '“ haben wir kein Produkt. Ähnliche Treffer:</div>';
    }
    return '';
  }

  /* =========================================================
     Teil 4: Schnellsuche im Header (ersetzt die Abfrage des Themes)
     ========================================================= */

  function schnellsucheEinbauen() {
    if (typeof PredictiveSearch === 'undefined') return false; // eslint-disable-line no-undef
    var proto = PredictiveSearch.prototype; // eslint-disable-line no-undef
    if (proto.__ps1a) return true;
    proto.__ps1a = true;
    var original = proto.getSearchResults;

    proto.getSearchResults = function (suchbegriff) {
      var self = this;
      var q = suchbegriff;
      this.__ps1aQ = q;
      if (this.promoModal && this.classList.contains('search-modal__form')) this.promoModal.classList.add('search__modal--hidden');
      if (this.collectionList) this.collectionList.classList.add('hidden');
      this.setLiveRegionLoadingState();
      ladeIndex().then(function (idx) {
        if (self.__ps1aQ !== q) return;
        self.renderSearchResults(dropdownHtml(q, idx));
        self.hidePromoBlock();
      }).catch(function () {
        original.call(self, suchbegriff);
      });
    };

    // Pfeiltasten durch Produkte und Vorschläge
    var originalKeyup = proto.onKeyup;
    proto.onKeyup = function (e) {
      if (e.code === 'ArrowDown' || e.code === 'ArrowUp') return;
      return originalKeyup.call(this, e);
    };

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var ps = e.target.closest && e.target.closest('predictive-search');
      if (!ps || !ps.querySelector('[data-ps1a]')) return;
      var opts = Array.prototype.slice.call(ps.querySelectorAll('[data-ps1a] [role="option"]')).filter(function (o) { return o.offsetParent !== null; });
      if (!opts.length) return;
      e.preventDefault();
      var akt = opts.findIndex(function (o) { return o.getAttribute('aria-selected') === 'true'; });
      if (akt >= 0) opts[akt].setAttribute('aria-selected', 'false');
      var neu = e.key === 'ArrowDown' ? akt + 1 : akt - 1;
      if (neu < 0) { if (ps.input) ps.input.setAttribute('aria-activedescendant', ''); return; }
      if (neu >= opts.length) neu = opts.length - 1;
      opts[neu].setAttribute('aria-selected', 'true');
      opts[neu].scrollIntoView({ block: 'nearest' });
    }, true);

    // Index vorladen, sobald jemand das Suchfeld anfasst
    document.addEventListener('focusin', function (e) {
      if (e.target && e.target.matches && e.target.matches('input[type="search"]')) ladeIndex();
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.header__search')) ladeIndex();
    });
    return true;
  }

  /* =========================================================
     Teil 5: Suchergebnisseite /search
     ========================================================= */

  // Ergebnisseite im Aufbau der Kollektionsseiten: gleiche Kopfzeile, Filter-Box links, gleiche Produktkarten.
  // Die Karten rendert das Theme selbst (Baustein product-card) über templates/product.suchkarte.liquid.
  var ICON_CARET = '<svg width="20" height="20" viewBox="0 0 20 20" class="icon icon-caret" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 8L10 12L6 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_HAKEN = '<svg class="icon icon-checkmark" width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 3.5L3 5.5L7 1.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var PRO_SEITE = 20;

  var kartenCache = {};
  function ladeKarten(handles) {
    return Promise.all(handles.filter(function (h) { return !kartenCache[h]; }).map(function (h) {
      return fetch(mitVorschau('/products/' + encodeURIComponent(h) + '?view=suchkarte'), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) { if (html.indexOf('data-ps1a-handle') !== -1) kartenCache[h] = html.trim(); })
        .catch(function () { /* Ersatzkarte */ });
    }));
  }

  function ergebnisseiteEinbauen() {
    // Nur auf /search: eigener Bereich oben in <main>, die Theme-Suche darunter wird erst ausgeblendet, wenn der Index geladen ist
    if (!document.body.classList.contains('template-search')) return;
    var main = document.getElementById('MainContent');
    if (!main) return;
    var wurzel = document.createElement('div');
    wurzel.className = 'ps1a-seite';
    wurzel.setAttribute('data-ps1a-seite', '');
    main.insertBefore(wurzel, main.firstChild);

    var params = new URLSearchParams(location.search);
    var zustand = { q: (params.get('q') || '').trim(), lager: '', marken: {}, typen: {}, min: '', max: '', sort: 'relevanz', zeige: PRO_SEITE };
    var idx = null;
    var liste = [];
    var laedt = false;

    wurzel.innerHTML = '<div class="container"><p class="ps1a-seite__laden">Suchergebnisse werden geladen …</p></div>';

    // Solange nichts steht, bleiben die Bereiche darunter unsichtbar (sonst blitzen Kollektions-Kacheln und Sale-Banner oben auf)
    function bereit() { document.body.classList.add('ps1a-bereit'); }
    var notfall = setTimeout(bereit, 6000);
    ladeIndex().then(function (i) {
      idx = i;
      geruest();
      zeichnen();
    }).catch(function () {
      wurzel.remove();
      document.body.classList.add('ps1a-aus'); // Theme-Suche wieder zeigen
      clearTimeout(notfall); bereit();
    });

    function geruest() {
      wurzel.innerHTML =
        '<div class="collection-hero color-background-1 background">' +
          '<div class="container"><div class="collection-hero__wrapper"><div class="collection-hero__text-wrapper">' +
            '<div class="page-header"><div class="page-header__inner"><h1 class="collection-hero__title title--page h2" data-titel></h1></div></div>' +
            '<form class="ps1a-seite__form" action="/search" method="get" role="search">' +
              '<input type="search" name="q" value="' + esc(zustand.q) + '" placeholder="Produkt, Marke oder Artikelnummer suchen" autocomplete="off" aria-label="Suchbegriff">' +
              '<input type="hidden" name="options[prefix]" value="last">' +
              '<button type="submit" class="button button--primary">Suchen</button>' +
            '</form>' +
            '<div data-hinweis></div>' +
            '<div class="ps1a-seite__chips" data-chips></div>' +
          '</div></div></div>' +
        '</div>' +
        '<div class="container ps1a-seite__unten">' +
          '<button type="button" class="button button--primary ps1a-seite__filterknopf" data-filterknopf>Filtern und sortieren</button>' +
          '<div class="collection-wrapper collection-wrapper--4 collection-wrapper--vertical">' +
            '<div class="facets-container facets-container--vertical ps1a-facets" data-facets>' +
              '<div class="facets">' +
                '<div class="facets__product-count" role="status"><h2 class="facets__product-count-text body-small"><span data-anzahl></span></h2></div>' +
                '<form class="facets__form facets__form--vertical" data-filterform>' +
                  '<div class="facets__horizontal-top"><div class="facets__sort-wrapper facets__sort-wrapper_vertical"><div class="facet-filters facets-sorting sorting">' +
                    '<label class="facets-sorting__label" for="Ps1aSortBy">Sortiere nach</label>' +
                    '<div class="facet-filters__field facets-sorting__field"><div class="select field">' +
                      '<select name="sort" class="select__select focus-inset" id="Ps1aSortBy">' +
                        '<option value="relevanz">Am relevantesten</option>' +
                        '<option value="bestseller">meistverkauft</option>' +
                        '<option value="lieferbar">Sofort lieferbar zuerst</option>' +
                        '<option value="preis-auf">Preis, niedrig nach hoch</option>' +
                        '<option value="preis-ab">Preis, hoch nach niedrig</option>' +
                        '<option value="az">Alphabetisch, A-Z</option>' +
                      '</select>' + ICON_CARET +
                    '</div></div>' +
                  '</div></div></div>' +
                  '<div class="facets__container"><div class="facets__wrapper facets__wrapper--vertical" data-filter></div></div>' +
                '</form>' +
              '</div>' +
            '</div>' +
            '<div class="products-grid">' +
              '<div class="collection collection-product">' +
                '<ul class="collection-product-list collection-product-list--4-items collection-product-list--2-mobile" data-karten></ul>' +
                '<div class="ps1a-seite__leer" data-leer hidden></div>' +
                '<div class="ps1a-seite__mehr" data-mehr></div>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>';

      var input = wurzel.querySelector('input[type="search"]');
      var timer;
      input.addEventListener('input', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          zustand.q = input.value.trim();
          zustand.marken = {}; zustand.typen = {}; zustand.lager = ''; zustand.min = ''; zustand.max = '';
          try { history.replaceState(null, '', suchUrl(zustand.q)); } catch (e) { /* egal */ }
          zeichnen();
        }, 250);
      });
      var form = wurzel.querySelector('[data-filterform]');
      form.addEventListener('submit', function (e) { e.preventDefault(); });
      form.addEventListener('change', function (e) {
        var el = e.target;
        if (el.name === 'sort') zustand.sort = el.value;
        else if (el.name === 'lager') zustand.lager = el.checked ? el.value : '';
        else if (el.name === 'marke') { if (el.checked) zustand.marken[el.value] = 1; else delete zustand.marken[el.value]; }
        else if (el.name === 'typ') { if (el.checked) zustand.typen[el.value] = 1; else delete zustand.typen[el.value]; }
        else if (el.name === 'min') zustand.min = el.value;
        else if (el.name === 'max') zustand.max = el.value;
        else return;
        if (el.name === 'lager') Array.prototype.forEach.call(form.querySelectorAll('input[name="lager"]'), function (x) { if (x !== el) x.checked = false; });
        zeichnen(el.name);
      });
      form.addEventListener('click', function (e) {
        var reset = e.target.closest('[data-reset]');
        if (!reset) return;
        e.preventDefault(); e.stopPropagation();
        var w = reset.getAttribute('data-reset');
        if (w === 'preis') { zustand.min = ''; zustand.max = ''; }
        if (w === 'lager') zustand.lager = '';
        if (w === 'marke') zustand.marken = {};
        if (w === 'typ') zustand.typen = {};
        zeichnen();
      });
      wurzel.querySelector('[data-filterknopf]').addEventListener('click', function () {
        wurzel.querySelector('[data-facets]').classList.toggle('ist-offen');
      });
      wurzel.querySelector('[data-mehr]').addEventListener('click', function (e) {
        if (e.target.closest('[data-mehrknopf]')) mehr();
      });
      // Endlos scrollen: nächste 20 Produkte laden, sobald das Ende der Liste in Sicht kommt
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (eintraege) {
          if (eintraege[0].isIntersecting) mehr();
        }, { rootMargin: '600px 0px' }).observe(wurzel.querySelector('[data-mehr]'));
      }
    }

    function mehr() {
      if (laedt || zustand.zeige >= liste.length) return;
      zustand.zeige += PRO_SEITE;
      karten(true);
    }

    function zaehle(basis, feld) {
      var z = {};
      basis.forEach(function (x) { var k = x.d.p[feld] || 'Sonstiges'; z[k] = (z[k] || 0) + 1; });
      return Object.keys(z).map(function (k) { return [k, z[k]]; }).sort(function (a, b) { return b[1] - a[1] || a[0].localeCompare(b[0]); });
    }

    function gruppe(id, titel, inhalt, aktiv) {
      return '<details class="disclosure-has-popup facets__disclosure js-filter" open>' +
        '<summary class="facets__summary focus-inset"><div class="facets__summary-inner">' +
          '<span class="facets__summary-title">' + titel + ICON_CARET + '</span>' +
          (aktiv ? '<a href="#" class="facets__reset link" data-reset="' + id + '">Zurücksetzen</a>' : '') +
        '</div></summary>' +
        '<div class="facets__display">' + inhalt + '</div>' +
      '</details>';
    }

    function haken(name, wert, text, anzahl, an, nr) {
      var id = 'Ps1a-' + name + '-' + nr;
      return '<li class="list-menu__item facets__item body-small">' +
        '<input type="checkbox" class="focus-inset" name="' + name + '" value="' + esc(wert) + '" id="' + id + '"' + (an ? ' checked' : '') + '>' +
        '<label for="' + id + '" class="facet-checkbox">' + ICON_HAKEN +
          '<span class="facet-checkbox__label">' + esc(text) + ' <span class="ps1a-facet-n">(' + anzahl + ')</span></span>' +
        '</label></li>';
    }

    function zeichnen(geaendert) {
      var q = zustand.q;
      wurzel.querySelector('[data-titel]').innerHTML = q ? 'Suchergebnisse für „' + esc(q) + '“' : 'Suche';
      document.title = (q ? 'Suche: ' + q : 'Suche') + ' – 1ASOL';

      var alternative = q ? alternativeFuer(q) : null;
      var erg = alternative ? nurTypen(idx.suche(alternative.suche), alternative.typen) : q ? idx.suche(q) : { treffer: [], exakt: true, qt: [] };
      var basis = erg.treffer;
      wurzel.querySelector('[data-hinweis]').innerHTML = q ? hinweisHtml(q, erg, alternative).replace('ps1a__hinweis', 'ps1a__hinweis ps1a-seite__hinweis') : '';

      // Vorschläge und Kategorien als Chips unter dem Suchfeld
      var chips = [];
      vorschlaege(q, root.ASOL_SUCHBEGRIFFE, 8).forEach(function (v) {
        if (tokens(v).join('') !== tokens(q).join('')) chips.push('<a class="ps1a-chip" href="' + suchUrl(v) + '">' + esc(v) + '</a>');
      });
      idx.kategorienFuer(q, erg, 4).forEach(function (k) {
        chips.push('<a class="ps1a-chip ps1a-chip--kat" href="/collections/' + esc(k.h) + '">' + esc(k.t) + ' <span>' + k.n + '</span></a>');
      });
      serviceFuer(q).forEach(function (s) { chips.push('<a class="ps1a-chip ps1a-chip--kat" href="' + s.u + '">' + esc(s.t) + '</a>'); });
      wurzel.querySelector('[data-chips]').innerHTML = chips.join('');

      // Filtern
      var min = parseFloat(String(zustand.min).replace(',', '.')), max = parseFloat(String(zustand.max).replace(',', '.'));
      liste = basis.filter(function (x) {
        var p = x.d.p;
        if (zustand.lager === 'lieferbar' && !p.a) return false;
        if (zustand.lager === 'sofort' && (!p.a || p.l)) return false;
        if (Object.keys(zustand.marken).length && !zustand.marken[p.v]) return false;
        if (Object.keys(zustand.typen).length && !zustand.typen[p.y || 'Sonstiges']) return false;
        if (!isNaN(min) && p.p / 100 < min) return false;
        if (!isNaN(max) && p.p / 100 > max) return false;
        return true;
      });
      var s = zustand.sort;
      if (s === 'bestseller') liste = liste.slice().sort(function (a, b) { return b.d.pop - a.d.pop; });
      if (s === 'preis-auf') liste = liste.slice().sort(function (a, b) { return (a.d.p.p || 9e12) - (b.d.p.p || 9e12); });
      if (s === 'preis-ab') liste = liste.slice().sort(function (a, b) { return (b.d.p.p || 0) - (a.d.p.p || 0); });
      if (s === 'az') liste = liste.slice().sort(function (a, b) { return a.d.p.t.localeCompare(b.d.p.t, 'de'); });
      if (s === 'lieferbar') liste = liste.slice().sort(function (a, b) {
        var ra = !a.d.p.a ? 2 : a.d.p.l ? 1 : 0, rb = !b.d.p.a ? 2 : b.d.p.l ? 1 : 0;
        return ra - rb || b.s - a.s;
      });

      // Filter-Box (Preisfelder nicht neu zeichnen, während man tippt)
      if (geaendert !== 'min' && geaendert !== 'max') {
        var f = '';
        var preise = basis.map(function (x) { return x.d.p.p / 100; }).filter(function (x) { return x > 0; });
        var hoechst = preise.length ? Math.ceil(Math.max.apply(null, preise)) : 0;
        f += gruppe('preis', 'Preis',
          '<div class="facets__price"><div class="facets__price-wrapper">' +
            '<label class="field__label visually-hidden" for="Ps1a-min">Aus</label><div class="field"><span class="field__currency">€</span><input class="field__input" name="min" id="Ps1a-min" type="number" min="0" placeholder="0" value="' + esc(zustand.min) + '"></div>' +
            '<label class="field__label visually-hidden" for="Ps1a-max">Zu</label><div class="field"><span class="field__currency">€</span><input class="field__input" name="max" id="Ps1a-max" type="number" min="0" placeholder="' + hoechst + '" value="' + esc(zustand.max) + '"></div>' +
          '</div></div>', zustand.min !== '' || zustand.max !== '');
        var lieferbar = basis.filter(function (x) { return x.d.p.a; }).length;
        var sofort = basis.filter(function (x) { return x.d.p.a && !x.d.p.l; }).length;
        f += gruppe('lager', 'Verfügbarkeit', '<ul class="facets__list list-unstyled" role="list">' +
          haken('lager', 'sofort', 'Auf Lager (2–4 Werktage)', sofort, zustand.lager === 'sofort', 1) +
          haken('lager', 'lieferbar', 'Bestellbar', lieferbar, zustand.lager === 'lieferbar', 2) + '</ul>', !!zustand.lager);
        var marken = zaehle(basis, 'v');
        if (marken.length > 1 || Object.keys(zustand.marken).length) {
          f += gruppe('marke', 'Marke', '<ul class="facets__list list-unstyled" role="list">' + marken.map(function (m, i) {
            return haken('marke', m[0], m[0], m[1], zustand.marken[m[0]], i);
          }).join('') + '</ul>', Object.keys(zustand.marken).length > 0);
        }
        var typen = zaehle(basis, 'y');
        if (typen.length > 1 || Object.keys(zustand.typen).length) {
          f += gruppe('typ', 'Produkttyp', '<ul class="facets__list list-unstyled" role="list">' + typen.map(function (m, i) {
            return haken('typ', m[0], m[0], m[1], zustand.typen[m[0]], i);
          }).join('') + '</ul>', Object.keys(zustand.typen).length > 0);
        }
        wurzel.querySelector('[data-filter]').innerHTML = f;
        wurzel.querySelector('#Ps1aSortBy').value = zustand.sort;
      }
      wurzel.querySelector('[data-facets]').hidden = !basis.length;
      wurzel.querySelector('[data-filterknopf]').hidden = !basis.length;

      var leer = wurzel.querySelector('[data-leer]');
      if (q && !basis.length) {
        leer.hidden = false;
        leer.innerHTML = '<p><strong>Keine Produkte zu „' + esc(q) + '“ gefunden.</strong></p><p>Tipp: nur die Marke oder die Modellreihe eingeben, zum Beispiel „Fronius“ oder „Reserva“. Oder rufen Sie uns an: <a href="tel:+4952315681430">05231 5681430</a> (Mo bis Fr, 9 bis 16 Uhr). Wir prüfen gern, ob wir das Produkt besorgen können: <a href="/pages/kontakt">Anfrage senden</a></p>';
      } else {
        leer.hidden = true;
      }

      zustand.zeige = PRO_SEITE;
      karten(false);
    }

    // Karten der sichtbaren Produkte vom Theme holen und in Trefferreihenfolge einsetzen
    var zeichenNr = 0;
    function karten(anhaengen) {
      var nr = ++zeichenNr;
      var ul = wurzel.querySelector('[data-karten]');
      var von = anhaengen ? ul.children.length : 0;
      var teil = liste.slice(von, zustand.zeige);
      var handles = teil.map(function (x) { return x.d.p.h; });
      zaehlerSetzen();
      if (!anhaengen) {
        ul.innerHTML = teil.slice(0, 8).map(function () {
          return '<li class="collection-product-card collection-product-card--small ps1a-platzhalter" aria-hidden="true"><span></span><i></i><i></i></li>';
        }).join('');
      }
      if (!handles.length) { mehrKnopf(); clearTimeout(notfall); bereit(); return; }
      laedt = true;
      ul.classList.add('ps1a-laedt');
      var pakete = [];
      for (var i = 0; i < handles.length; i += PRO_SEITE) pakete.push(ladeKarten(handles.slice(i, i + PRO_SEITE)));
      Promise.all(pakete).catch(function () { /* Ersatzkarte unten */ }).then(function () {
        laedt = false;
        ul.classList.remove('ps1a-laedt');
        if (nr !== zeichenNr) return;
        Array.prototype.forEach.call(ul.querySelectorAll('.ps1a-platzhalter'), function (el) { el.remove(); });
        ul.insertAdjacentHTML('beforeend', teil.map(function (x) {
          return kartenCache[x.d.p.h] || ersatzKarte(x.d.p);
        }).join(''));
        try { if (typeof colorSwatches === 'function') colorSwatches(); } catch (e) { /* egal */ } // eslint-disable-line no-undef
        mehrKnopf();
        clearTimeout(notfall); bereit();
      });
    }

    function zaehlerSetzen() {
      var gezeigt = Math.min(zustand.zeige, liste.length);
      wurzel.querySelector('[data-anzahl]').textContent = 'Es werden ' + gezeigt + ' von ' + liste.length + ' Produkten angezeigt';
    }

    function mehrKnopf() {
      zaehlerSetzen();
      var rest = liste.length - zustand.zeige;
      wurzel.querySelector('[data-mehr]').innerHTML = rest > 0
        ? '<button type="button" class="button button--secondary ps1a-seite__mehrknopf" data-mehrknopf>Weitere Produkte laden (' + rest + ')</button>'
        : '';
      // Ist das Listenende nach dem Einsetzen immer noch in Sicht, gleich weiterladen
      var box = wurzel.querySelector('[data-mehr]').getBoundingClientRect();
      if (rest > 0 && box.top < window.innerHeight + 600) setTimeout(mehr, 50);
    }

    // Falls eine Theme-Karte nicht geladen werden kann: schlichte Karte aus dem Index
    function ersatzKarte(p) {
      return '<li class="collection-product-card collection-product-card--small"><a class="ps1a-ersatzkarte" href="/products/' + esc(p.h) + '">' +
        bild(p, true) + '<span class="ps1a-ersatzkarte__titel">' + esc(p.t) + '</span>' + preis(p) + verfuegbarkeit(p) + '</a></li>';
    }
  }

  function start() {
    var n = 0;
    (function versuch() {
      if (!schnellsucheEinbauen() && n++ < 40) setTimeout(versuch, 100);
    })();
    ergebnisseiteEinbauen();
  }

  // Als defer-Skript im Header geladen: predictive-search.js kommt später, deshalb auf DOMContentLoaded warten
  var gestartet = false;
  function einmal() { if (!gestartet) { gestartet = true; start(); } }
  if (document.readyState === 'complete') einmal();
  else { document.addEventListener('DOMContentLoaded', einmal); window.addEventListener('load', einmal); }
})(typeof window !== 'undefined' ? window : globalThis);
